import { Box, Container, Typography } from "@mui/material";
import ContentHeader from "../../components/layout/ContentHeader/ContentHeader";
import ContentTitle from "../../components/layout/ContentTitle/ContentTitle";
import Section from "../../components/layout/Section/Section";
import Hr from "../../components/ui/Hr/Hr";
import { useState } from "react";
import ValidForm from "../../components/forms/ValidForm/ValidForm";
import { useGlobalState } from "../../context/AppContext";
import ContactForm from "../../components/forms/ContactForm/ContactForm";
import NavBreadcrumbs from "../../components/navigation/NavBreadcrumbs/NavBreadcrumbs";
import { PAGE } from "../../constants/page";
import { sendMail } from "../../services/mail_client";
import OtherSection from "../../components/display/OtherSection/OtherSection";

interface Props {
  children?: React.ReactElement<unknown>;
}

const texts1 = [
  <>
    メールにてお問い合わせをご希望の方は、下記メールフォームに情報を入力して送信ください。<br /><br />
    ご入力いただいたメールアドレス宛にご連絡をさせていただきますが、直接電話にてご連絡をさせていただく場合もございます。<br />
    なお、当フォーム経由でのお問い合せへのご対応は数日かかる場合がございます。<br />何卒ご了承下さい。<br /><br />
    いただきました個人情報につきましては、お問い合せ内容へのご対応に関するもの以外に使用することはございません。
  </>
]

export default function Contact(props: Props) {
  /** グローバルステート */
  const { state, setState } = useGlobalState()
  /** 入力項目 */
  const initForm = (): FormBase<Contact> => {
    return {
      value: {
        category: '',
        subject: '',
        name: '',
        company: '',
        email: '',
        tel: '',
        post: '',
        address: '',
        message: '',
      },
      invalid: {},
      customValidity: {}
    }
  }
  const [form, setForm] = useState<FormBase<Contact>>(initForm())

  /** 送信処理 */
  const handleSubmit = async (val: FormBase<Contact>, isValid: boolean) => {
    // 問い合わせ種別の選択状態を確認
    if (val.value.category) {
      val.invalid.category = ''
    } else {
      val.invalid.category = 'お問い合わせ種別を選択してください。'
      isValid = false
    }
    setForm({ ...val })
    if (isValid) {
      setState({
        ...state,
        dialog: {
          ...state.dialog,
          isOpen: true,
          title: (
            <>
              お問い合わせを送信しますか？
            </>
          ),
          content: (
            <>
              <Typography>お問い合わせを受け付けましたら、こちらから確認のメールを送信します。</Typography>
              <Typography>詳細につきましては、別途ご連絡いたします。</Typography>
            </>
          ),
          submitLabel: '送信する',
          cancelLabel: 'キャンセル',
          submitProcess: submitProcess
        }
      })
    } else {
      // 入力エラー時の処理
      setState({
        ...state,
        alert: {
          ...state.alert,
          isOpen: true,
          severity: 'error',
          message: (
            <>
              <Typography>入力内容を確認してください。</Typography>
            </>
          )
        }
      })
    }
  }

  /** 送信処理 */
  const submitProcess = async () => {
    // お問い合わせ送信リクエスト
    await sendMail<PostSendMailReq>({
      from_name: form.value.name,
      from_email: form.value.email,
      subject: `【${form.value.category}】${form.value.subject}`,
      message: `お問い合わせ種別: ${form.value.category}\n差出人: ${form.value.name} ${form.value.email}\n会社／学校名: ${form.value.company}\n電話番号: ${form.value.tel}\n郵便番号: ${form.value.post}\n住所: ${form.value.address}\n\nメッセージ本文:\n${form.value.message}\n\n--\n本メールはウェブサイト (${process.env.REACT_APP_NAME || ''} ${process.env.REACT_APP_URL || ''}) のお問い合わせフォームに送信があったことをお知らせするものです。`
    })
      .then(() => {
        setState({
          ...state,
          dialog: {
            ...state.dialog,
            isOpen: false
          },
          alert: {
            ...state.alert,
            isOpen: true,
            severity: 'success',
            message: (
              <>
                <Typography>お問い合わせを受け付けました。</Typography>
              </>
            )
          }
        })
        setForm(initForm())
      })
      .catch((error) => {
        // 送信エラー時の処理
        console.error(error)
        setState({
          ...state,
          alert: {
            ...state.alert,
            isOpen: true,
            severity: 'error',
            message: (
              <>
                <Typography>お問い合わせを送信できませんでした。</Typography>
                <Typography>しばらくしてから再度お試しください。</Typography>
              </>
            )
          }
        })
      })
  }

  return (
    <>
      <Section color="dark">
        <ContentHeader title={PAGE.CONTACT.NAME} subTitle={PAGE.CONTACT.TEXT} />
      </Section>

      <Section color="light" padding="1rem 0">
        <Container>
          <NavBreadcrumbs />
        </Container>
      </Section>

      <Section color="light">
        <Container>
          <ContentTitle title={'FORM'} subTitle={'お問い合わせフォーム'} />
          <Box sx={{ marginTop: '3rem', marginBottom: '3rem' }}>
            {texts1.map((t, index) => {
              return (
                <Typography key={index} variant="body1" color="text.primary">
                  {t}
                </Typography>
              )
            })}
          </Box>

          <Hr />

          <ValidForm
            form={form}
            submit={handleSubmit}
          >
            <ContactForm form={form} setForm={setForm} />
          </ValidForm>
        </Container >
      </Section >

      <Hr />

      <Section color='dark' height={'300px'} backgroundImage='url(/assets/images/top.jpg)' isBackgroundCover>
        <Container>
          <OtherSection isObserver={false} />
        </Container>
      </Section>
    </>
  )
}